import { render, staticRenderFns } from "./beauty-setting.vue?vue&type=template&id=729024d8&scoped=true&lang=pug"
import script from "./beauty-setting.vue?vue&type=script&lang=js"
export * from "./beauty-setting.vue?vue&type=script&lang=js"
import style0 from "./beauty-setting.vue?vue&type=style&index=0&id=729024d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729024d8",
  null
  
)

/* custom blocks */
import block0 from "./beauty-setting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports